<template>
    <div>
        <h1>{{$t('Lista_de_Notícias')}}</h1>

        <div class="mt25">
            <div class="centerx default-input flex flex-wrap">
                <router-link :to="{name: 'news-form'}">
                    <vs-button class="ml-3" color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle">{{$t('newa')}}</vs-button>
                </router-link>
            </div>
        </div>
        
        <!-- Start rendering news_info table here -->
        <div>
            <vs-table max-items="10" pagination search stripe :data="news_info">
                <template slot="thead">
                    <vs-th class="w50">
                        {{$t('newa')}}
                    </vs-th>
                    <vs-th class="w10">
                        {{$t('date')}}
                    </vs-th>
                    <vs-th class="w10">
                        <div class="mx-auto">
                            {{$t('Visivel')}}
                        </div>
                    </vs-th>
                    <vs-th class="w10">
                        <div class="mx-auto">
                            {{$t('Tipo')}}
                        </div>
                    </vs-th>
                    <vs-th class="w10">
                        <div class="mx-auto">
                            {{$t('Autor')}}
                        </div>
                    </vs-th>
                    <vs-th class="w10">
                    </vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="index" v-for="(news_item, index) in data" :style="(news_item.destaque == 1 ? 'background-color: lightgoldenrodyellow !important;' : '')">
                        <vs-td>
                            {{news_item.translation[0].titulo}}
                        </vs-td>
                        <vs-td>
                            {{news_item.created_date}}
                        </vs-td>
                        <vs-td>
                            <div class="text-center">
                                <vs-radio :color="getColorPublic(news_item.visivel, news_item.data_inicio, news_item.data_fim)"></vs-radio>
                            </div>
                        </vs-td>
                        <vs-td>
                            <div class="text-center">
                                <vx-tooltip :text="news_item.news_type.tipo">
                                    <feather-icon :icon="( news_item.news_type.tipo == 'Publica' ? 'RadioIcon' : 'TargetIcon' )" class="px-4 h-full"></feather-icon>
                                </vx-tooltip>
                            </div>
                        </vs-td>
                        <vs-td>
                            <div class="text-center">
                                <vx-tooltip :text="news_item.author.nome">
                                    <vs-avatar :text="news_item.autor" color="primary" :src="require('@/assets/images/portrait/small/img_user_default.png')"/>
                                </vx-tooltip>
                            </div>
                        </vs-td>
                        <vs-td>
                            <router-link :to="{name: 'news-form', params: { id: news_item.id }}">
                                <vs-button class="ml-3" color="primary" type="filled" icon-pack="feather" icon="icon-edit">{{$t('Detalhe')}}</vs-button>
                            </router-link>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
        <!-- Stop rendering news_info table here -->
    </div>
</template>

<script>
    
    export default {
        data(){
            return {
                news_info: [
                    // exemplo dos dados
                    // {
                    //     "id": "55",
                    //     "tipo": "2",
                    //     "titulo": "Covid 19 - As medidas tomadas pela Vila Galé",
                    //     "visivel": "1",
                    //     "destaque": "1",
                    //     "data_inicio":" null,
                    //     "data_fim":" null,
                    //     "autor":"Sofia Lopes",
                    //     "data": "16/03/2020",
                    //     "avatar":"https://image.freepik.com/free-photo/pensive-black-girl-walking-down-city-alley_1262-20288.jpg"
                    // },
                ]
            };
        },
        methods: {
            getList() {
                this.$vs.loading();
                this.$api.post( '/myvilagale/news/getList?token=' + localStorage.getItem('usertoken'),
                {
                    view: 'list-news'
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
                    }
                })
                .then((res) => {
                    this.$vs.loading.close();
                    this.news_info = res.data;
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },
            getColorPublic(visivel, data_inicio, data_fim) {
                var today = new Date();
                var data_hoje = today.getFullYear() + '-' +String(today.getMonth() + 1).padStart(2, '0')+ '-' +String(today.getDate()).padStart(2, '0');
                var a_mostrar = 0;
                if(
                    (data_inicio == null && data_fim == null) ||
                    (data_hoje >= data_inicio && data_hoje <= data_fim)
                ){
                    a_mostrar = visivel == 1 ? 1 : 0;
                }
                return a_mostrar == 1 ? 'success' : 'danger';
            },
            notify(text, color, seconds){
                var icon = 'icon-alert-circle';
                var time = seconds == null ? 5*1000 : seconds*1000;
                
                if(color == 'green'){
                    color = 'success';
                    icon = 'icon-check';
                }else if(color == 'red'){
                    color = 'danger';
                    icon = 'icon-alert-triangle';
                }else{
                    color = 'primary';
                }
                this.$vs.notify({
                    time: time,
                    text: text,
                    color: color,
                    iconPack: 'feather',
                    icon: icon
                })
            }
        },
        created(){
            this.getList();
        }
    }
</script>

<style>
    .mt25 {
        margin-top: 25px;
    }
    .w10{
        width: 10%;
    }
    .w50{
        width: 50%;
    }
    .con-pagination-table.vs-table--pagination .vs-row{
        display: flex !important;
        justify-content: flex-end !important;
    }
</style>

